import type { taskEither } from "fp-ts";

import type { Common, Create, Delete, Get, GetMany, GetPaginated, Resolve, Update } from "./ios";

import type { AuthenticationError, NotFoundError, UnexpectedError } from "~/shared/error";

abstract class Provider {
  abstract create(params: Create.In): taskEither.TaskEither<UnexpectedError, void>;
  abstract update(
    params: Update.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, Common.OutSchema>;
  abstract delete(
    params: Delete.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, void>;
  abstract resolve(
    params: Resolve.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, void>;
  abstract get(
    params: Get.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, Common.OutSchema>;
  abstract getMany(): taskEither.TaskEither<UnexpectedError | AuthenticationError, GetMany.Out>;
  abstract getPaginated(
    params: GetPaginated.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError, GetPaginated.Out>;
}

export { Provider };
